import React, {useEffect, useState} from 'react';

import {makeStyles} from "@material-ui/styles";

import muvaLogo from '../../../assets/muva-email-logo.png';

function PreviewTemplate(props) {
    const cn = useStyles();

    return (
        <div className={cn.previewContainer}>
            <div className={cn.previewTitle}>Preview</div>
            <div className={cn.previewBoxContainer}>
                <div className={cn.previewBox}>
                    <div className={cn.muvaLogo}>
                        <img src={muvaLogo} width={180} height={80} />
                    </div>
                    <div className={cn.previewContent}>
                        <div className={cn.previewEmailTitle}>Helloo {props.moverName},</div>
                        <div className={cn.previewParagraph}>{props.initialText}</div>
                        <div className={cn.previewDetailsTitle}>Details</div>
                        <div className={cn.previewParagraph}>
                            {props.details && props.details.map((m,i)=>(
                            <div key={i} >{m.k ==! " " ?  m.k : m.k + ":"} {m.v}</div>
                            ))}
                            
                        </div>
                        <br/>
                        <div className={cn.previewParagraph}>{props.footerText} </div>
                        <div className={cn.previewEmailFooter}>
                            <div>Have a nice day,</div>
                            <div>-The MUVA team</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const useStyles = makeStyles({
    previewDetailsTitle: {
        fontWeight: '900',
        fontSize: '13px',
        marginTop: '15px',
    },
    previewParagraph: {
        fontSize: '13px',
        lineHeight: '1.4',
    },
    previewEmailTitle: {
        fontWeight: '900',
        fontSize: '15px',
        marginBottom: '15px',

    },
    previewEmailFooter: {
        fontSize: '13px',
        marginTop: '15px',
    },
    muvaLogo: {
        display: 'flex',
        justifyContent: 'center',
        marginBottom: '25px',
        width: '100%',
    },
    previewContainer: {
        background: '#eaeaea',
        height: '100%',
        border: '5px dotted #e2e2e2',
    },
    previewBoxContainer: {
        display: 'flex',
        justifyContent: 'center',
    },
    previewTitle: {
        marginTop: '25px',
        fontWeight: 'bold',
        fontSize: '15px',
        color: '#757575',
        marginLeft: '20px',
    },
    previewBox: {
        marginTop: '25px',
        width: '70%',
    },
    previewContent: {
        background: 'white',
        height: 'auto',
        width: '100%',
        padding: '15px',
    },
    
});

export default PreviewTemplate;
